import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { CreateDataRequestDto } from '#pie/internal/api/pie-bff';
import { DataLevel, DataLevelZipCode } from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormText } = typedFormFields<CreateDataRequestDto>();

export const LevelNote = () => {
  // Welke plaats(en)/gemeente(s)/RES-regio('s)/provincie(s) note?
  const { t } = useTranslation('dataRequest');
  const { watch } = useFormContext<CreateDataRequestDto>();
  const level = watch('level');

  const getLabel = (level: DataLevel | undefined) => {
    switch (level) {
      case DataLevel.Province:
        return t('province_level');
      case DataLevel.ResRegion:
        return t('res_region_level');
      case DataLevel.Municipality:
        return t('municipality_level');
      case DataLevel.City:
        return t('city_level');
      default:
        return '';
    }
  };
  return (
    <ConditionalField
      field="levelNote"
      condition={(fieldValue) =>
        fieldValue('level') === DataLevel.Province ||
        fieldValue('level') === DataLevel.ResRegion ||
        fieldValue('level') === DataLevel.Municipality ||
        fieldValue('level') === DataLevel.City
      }
      keepDataCondition={(fieldValue) =>
        fieldValue('level') === DataLevel.Province ||
        fieldValue('level') === DataLevel.ResRegion ||
        fieldValue('level') === DataLevel.Municipality ||
        fieldValue('level') === DataLevel.City ||
        fieldValue('level') === DataLevel.Other ||
        fieldValue('level') === DataLevelZipCode.Other
      }
    >
      <FormText
        label={getLabel(level)}
        fullWidth
        name="levelNote"
        showWordCount
        rules={{ maxLength: 200, minLength: 2, required: true }}
      />
    </ConditionalField>
  );
};
